module.exports = __webpack_public_path__ + "img/share.ce1270ae.svg";